import { createContext, ElementType, forwardRef, useState } from 'react';
import styled from 'styled-components';

interface Props {
  className?: string;
  id?: string;
  children: React.ReactNode;
  dataAttrs?: { [key: string]: string };
  // 任意のタグで使うための型定義
  as?: ElementType;
}

/* viewableの親要素に指定するcss */
const Wrapper = styled.div`
  position: relative;
`;

/**
 * ViewableElementの親要素
 * 必ずViewableElementとセットでimportして使用してください。
 * 実装後はコンソールエラーが出ないことを確認してください。
 *
 * また、asPropsとスタイル拡張を併用する場合は、forwardedAsでタグ名を渡してください
 * 例）<StyledViewableElementWrapper forwardedAs="li"><ViewableElement/></StyledViewableElementWrapper>
 */

export const ViewableElementContext = createContext(false);
export const ViewableElementWrapper = forwardRef<HTMLElement, Props>(
  ({ className, id, children, as, dataAttrs }, ref) => {
    const [hasWrapper] = useState(true);
    const asTag = as ? as : 'div';

    return (
      <ViewableElementContext.Provider value={hasWrapper}>
        <Wrapper className={`${className} viewableWrapper`} id={id} as={asTag} ref={ref} {...dataAttrs}>
          {children}
        </Wrapper>
      </ViewableElementContext.Provider>
    );
  }
);
